<template>
    <div class="intervention-block">
        <div v-if="!valid" class="text-xs-center pa-4 d-flex align-center">
            <div style="width: 100%;" class="intervention-block-main">
                <div>
                    <div class="intervention-block-title">Intervention</div>
                    <span class="intervention-block-subtitle">
                        Link an intervention plan to display. This field will not print unless an intervention is linked.
                    </span>
                </div>
                <fe-btn usage="secondary" 
                    @click="showLinkForm = true" 
                    data-test="smartform-intervention-block-link-intervention-btn"
                    role="button"
                    tabindex="0"
                    aria-label="Open link interventions"
                    @keydown.enter="showLinkForm = true"
                    @keydown.space.prevent="showLinkForm = true"
                >
                    <v-icon class="mr-2">fal fa-link</v-icon>Link Intervention
                </fe-btn>
            </div>
        </div>

        <div v-else class="ma-4">
            <div v-if="linkedToFormField">
                <div class="mb-2 align-center d-flex modal-title" style="font-size: 18px;">
                    {{ linkedToFormField.plan_name }}
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <fe-btn v-on="on" usage="secondary">
                                Update Intervention <v-icon class="ml-2">fal fa-chevron-down</v-icon>
                            </fe-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="showLinkForm = true"
                                data-test="smartform-intervention-block-select-new-intervention-btn"
                            >
                                Select Another Intervention
                            </v-list-item>
                            <v-list-item @click="removeIntervention"
                                style="color: #BF0D00;"
                                data-test="smartform-intervention-block-remove-intervention-btn"
                            >
                                Remove Intervention
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <span style="font-size: 12px;" v-safe-html="linkedToFormField.intervention_plan_statement"/>
            </div>
        </div>
        
        <link-interventions 
            ref="interventionLinkForm" 
            v-model="showLinkForm" 
            :formInstance="formInstance" 
            :fieldRec="fieldRec" 
            :linkedInterventions="params.interventions"
            @reload="onReload" 
        />
    </div>
</template>

<script>
    import LinkInterventions from './LinkInterventions';

    export default {
        name: 'InterventionBlock',
        props: {
            formInstance: {
                type: Object,
                default: () => ({})
            },
            fieldRec: {
                type: Object,
                default: () => ({})
            },
            params: {
                type: Object,
                default: () => ({})
            }
        },
        components: {
            LinkInterventions,
        },
        computed: {
            valid() {
                return this.params?.interventions?.length && this.linkedToFormField
            },
            studentId() {
                return this.valid && this.formInstance?.first_student_id
            },
            linkedToFormField() {
                return this.params?.interventions?.find(x => x.form_field_id === this.fieldRec?.form_field_id) || null
            }
        },
        data() {
            return {
                showLinkForm: false,
            }
        },
        methods: {
            async removeIntervention() {
                let existing = await this.$refs?.interventionLinkForm?.getInterventions()
                let planToRemove = existing.find(x => x.intervention_id === this.linkedToFormField.id)
                if (planToRemove) this.$refs?.interventionLinkForm?.doUnlink(planToRemove)
            },
            onReload() {
                this.$emit('reloadInterventionLink')
            }
        },
    }
</script>

<style lang="scss" scoped>
    .intervention-block {
        border: 1px solid #E0E1E6;
        border-radius: 4px;
        margin: 8px 0 8px 0;
        &-title {
            font-size: 16px; 
            font-family: 'HyperlegibleSans-Medium', Hyperlegible Sans, 'Roboto', sans-serif;
        }
        &-subtitle {
            color: #495B8F;
        }
        &-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .modal-title {
        justify-content: space-between;
    }
</style>
